import { forwardRef } from 'react';
import type { SVGIconProps } from '../types';

/** Windows の Alt キー表示用オリジナルアイコン（lucide に等価記号がないため独自）。 */
export const OriginalAltKeyWindowsIcon = forwardRef<SVGSVGElement, SVGIconProps>(({
  color = 'currentColor',
  size = 16,
  ...props
}, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 14H6L10 2H14M9.33333 14H14" stroke={color} strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
  </svg>);
OriginalAltKeyWindowsIcon.displayName = 'OriginalAltKeyWindowsIcon';